// src/services/unlockRules.js
import { TrophyStorage } from "./trophyStorage";

export function getRoundInProgressSafe() {
  const s = TrophyStorage.getState();
  return s?.roundInProgress || null;
}

/**
 * maxUnlockedLevel rule:
 * - If no round yet (or trophy collected ended it): only Level 1 is unlocked.
 * - If lastLevelCompleted is null: only Level 1 is unlocked.
 * - Else: unlocked = all levels <= lastLevelCompleted, plus NEXT level (last+1), capped at 10.
 */
export function getMaxUnlockedLevel() {
  const rip = getRoundInProgressSafe();

  if (!rip) return 1;

  const last = Number(rip.lastLevelCompleted);
  if (!Number.isFinite(last) || last <= 0) return 1;

  return Math.min(10, last + 1);
}

export function isLevelUnlocked(levelId) {
  const n = Number(levelId);
  if (!Number.isFinite(n) || n <= 0) return false;
  return n <= getMaxUnlockedLevel();
}

/** Where to send user if they try a locked level */
export function getRedirectLevelPath() {
  const max = getMaxUnlockedLevel();
  return `/level-${max}`;
}
